function onDialogCancel() {}

export default onDialogCancel;
